/**
 * Created by Andrey Popov on 04.08.2025
 */

const Merge2Customer = function (customerIndex, customers) {
    cleverapps.EventEmitter.call(this);

    this.customerIndex = customerIndex;

    this.customers = customers;

    this.onGetView = function () {};

    customers.on("onRecipesUpdated", this.updateReady.bind(this), this);
};

Merge2Customer.prototype = Object.create(cleverapps.EventEmitter.prototype);
Merge2Customer.prototype.constructor = Merge2Customer;

Merge2Customer.prototype.setRecipe = function (data) {
    this.recipe = new Merge2CustomerRecipe(data);
    this.setRaveReviewsReward(false, true);
    this.updateRewards();
    this.updateReady();
};

Merge2Customer.prototype.updateReady = function () {
    const isReady = this.recipe && this.recipe.isEnoughIngredients();
    if (isReady !== this.isReady) {
        this.isReady = isReady;
        cleverapps.eventBus.trigger("order_ready_changed", this.isReady);
    }
};

Merge2Customer.prototype.updateRewards = function () {
    if (this.recipe) {
        const fullReward = this.recipe.prizesToRewards();

        this.reward = new RewardsList(fullReward, {
            event: cleverapps.EVENTS.EARN.CUSTOMER_ORDER
        });
    }
};

Merge2Customer.prototype.hasRaveReviewsReward = function () {
    return Boolean(this.raveReviewReward);
};

Merge2Customer.prototype.setRaveReviewsReward = function (enabled, silent) {
    if (enabled) {
        this.raveReviewReward = new RewardsList({ rave_reviews: cleverapps.raveReviews.calcOrderReward(this.recipe.calcOrderStars()) }, { event: cleverapps.EVENTS.EARN.CUSTOMER_ORDER });
    } else {
        this.raveReviewReward = undefined;
    }

    this.trigger("raveReviewChanged", silent);
};

Merge2Customer.prototype.order = function (data) {
    this.setRecipe(data);

    cleverapps.effects.fire("merge.order.new");

    Field.mapEvent(Field.RECIPE_NEW, { source: this });

    this.customers.updateMarks();
};

Merge2Customer.prototype.replaceOrder = function (data) {
    if (this.recipe) {
        this.setRecipe(data);

        Field.mapEvent(Field.RECIPE_CHANGE, { source: this });

        this.customers.updateMarks();
    }
};

Merge2Customer.prototype.exchange = function (callback) {
    cleverapps.tutorial.trigger("onCustomerExchange");
    Field.mapEvent(Field.BEFORE_EXCHANGE, { source: this });

    if (this.canCook()) {
        const recipe = this.recipe;
        this.recipe = undefined;

        if (recipe.index !== undefined && !recipe.sideQuest && !recipe.isAutoOrder) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.ORDER_COMPLETE, {
                itemId: `${recipe.index}`
            });
        }

        if (!recipe.sideQuest && cleverapps.energyBooster.isActive()) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.ENERGY_BOOSTER_BONUS, { value: cleverapps.energyBooster.getOrderEnergy(recipe.ingredients) });
        }

        const reward = this.reward;
        this.reward = undefined;

        const raveReviewReward = this.raveReviewReward;
        this.raveReviewReward = undefined;

        Merge2.current.stock.takeIngredients(recipe.ingredients, {
            customer: this,
            callback
        });

        cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
        cleverapps.eventBus.trigger("complete_order");
        cleverapps.eventBus.trigger("order_stars", recipe.getBonusStar().amount);

        cleverapps.user.incProgressCompare();

        if (reward) {
            reward.receiveRewards();
        }

        if (raveReviewReward) {
            raveReviewReward.receiveRewards();
        }

        let exchangeDuration = 0;
        if (this.onGetView()) {
            exchangeDuration = 1550 + this.onGetView().person.getAnimationDuration("hide") * 1000;
        }
        this.customers.startExchangeTimeout(exchangeDuration);
        this.customers.onCompleteOrder(this, recipe);

        Field.mapEvent(Field.EXCHANGE, { source: this });
    } else {
        callback();
    }
};

Merge2Customer.prototype.getCurrentRecipe = function () {
    return this.recipe;
};

Merge2Customer.prototype.canCook = function () {
    return this.recipe && Merge2.current.stock.canTakeIngredients(this.recipe.ingredients);
};

Merge2Customer.prototype.collectUnit = function (unit, callback) {
    const view = this.onGetView();
    if (view) {
        view.collectUnitAnimation(unit, callback);
        unit.remove(true);
    } else {
        unit.remove();
        callback();
    }
};

Merge2Customer.prototype.collectBackpackUnit = function (index, callback) {
    const unit = Merge2.current.backpack.takeUnit(index);
    const view = this.onGetView();
    if (view) {
        view.collectBackpackUnitAnimation(unit, callback);
    } else {
        callback();
    }
};